import React from 'react';
import {SVGIcon} from '@homeaway/react-svg';
import {COLLABORATE__24} from '../../../../svg-def';
import {FormattedHTMLMessage} from 'react-intl';
import './slide-3.less';


export const Slide3 = ({
}) => (
    <div className="trip-board-onboarding-slide3">
        <div className="trip-board-onboarding-slide3__gray-circle"/>

        <div className="trip-board-onboarding-slide3__family-getaway">
            <div className="header text-emphasis">
                <FormattedHTMLMessage id={'tripboards.main.empty.board1'} defaultMessage={''} description="Trip Board title"/>
            </div>
            <div className="left-content"/>
            <div className="right-content">
                <div className="right-content__top" />
                <div className="right-content__bottom" />
            </div>
        </div>
        <div className="trip-board-onboarding-slide3__invite-circle">
            <SVGIcon className="text-info" markup={COLLABORATE__24} />
        </div>
        <div className="trip-board-onboarding-slide3__person1"/>
        <div className="trip-board-onboarding-slide3__person2"/>
        <div className="trip-board-onboarding-slide3__person3"/>
    </div>
);

export default Slide3;



// WEBPACK FOOTER //
// ./src/universal/components/onboarding/content/static/slide-3/slide-3.js